import * as types from 'constants/action_types'

export function doToggleSearchModifier(open) {
  return {
    type: types.TOGGLE_SEARCH_MODIFIER,
    data: { open },
  }
}
